import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Container } from "react-bootstrap";
import styles from "./styles/style.module.scss";
import { handleImageLink } from "@/helpers/functions";
import SvgComponent from "@/components/Shared/SvgComponent";
// Import Components
import TabContent from "./TabContent";
import Heading from "@/components/Shared/Heading/Heading";

const How = ({ data }) => {
  const { locale } = useIntl();
  const [activeTab, setActiveTab] = useState(0);
  const [backgroundImage, setBackgroundImage] = useState("");
  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const getIconFillColor = (index) => {
    // const defaultFillColor = isDarkMode ? "#fff" : "#233654";
    const defaultFillColor = "#233654";
    const activeFillColor = "#e74c3c";

    // Return the appropriate fill color based on the active state
    return index === activeTab ? activeFillColor : defaultFillColor;
  };
  const updateBackgroundImage = (theme) => {
    if (data?.content?.darkBackgroundImage && data?.backgroundImage) {
      const newBackgroundImage =
        theme === "dark"
          ? handleImageLink(data?.content?.darkBackgroundImage)
          : handleImageLink(data?.backgroundImage);
      setBackgroundImage(newBackgroundImage);
    }
  };

  useEffect(() => {
    const theme =
      document.documentElement.getAttribute("data-theme") || "light";
    updateBackgroundImage(theme);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "data-theme") {
          const newTheme = document.documentElement.getAttribute("data-theme");
          updateBackgroundImage(newTheme);
        }
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, [data]);

  return (
    <section
      className={`${styles["mainHow"]} mainHow`}
      style={{
        backgroundImage: `url(${
          data?.content?.darkBackgroundImage && data?.backgroundImage
            ? backgroundImage
            : ""
        })`,
      }}
    >
      <Container>
        <Heading
          title={data?.title?.[locale]}
          subTitle={data?.subTitle?.[locale]}
          description={data?.subTitle?.description?.[locale]}
          styleTopTitle={true}
        />
        <div className="tabs-div">
          <ul className="nav-tabs">
            {data?.content?.items?.map((tab, index) => (
              <li className="nav-item" key={index}>
                <button
                  onClick={() => handleTabClick(index)}
                  className={
                    index === activeTab ? "nav-link active" : "nav-link"
                  }
                  aria-current={index === activeTab ? "true" : "false"}
                >
                  <div className="icon flex-center">
                    <SvgComponent
                      src={handleImageLink(tab?.icon)}
                      // fillColor="#ff000"
                      fillColor={getIconFillColor(index)}
                    />
                  </div>
                  {tab?.title?.[locale]}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="tab-content">
          <TabContent data={data?.content?.items?.[activeTab]} />
        </div>
      </Container>
    </section>
  );
};

export default How;
